import * as Scrivito from 'scrivito';
import { TrafficInfoWidgetAttributes, TrafficInfoWidgetId } from './traffic-info-widget-definitions';
import { spacingClassAttributes } from '../../utils/scrivito/spacing-definitions';

export const TrafficInfoWidgetClass = Scrivito.provideWidgetClass(TrafficInfoWidgetId, {
  attributes: {
    [TrafficInfoWidgetAttributes.DUMMY_DATA]: 'boolean',
    [TrafficInfoWidgetAttributes.DUMMY_AREA_INFO]: 'boolean',
    ...spacingClassAttributes(),
  },
});

export type TrafficInfoWidget = InstanceType<typeof TrafficInfoWidgetClass>;
